import {
    Table,
    TableSectionsData
} from "@/libraries/design/patterns/table/src/table";
import { useDwellTimeElementAttributes } from "@/utils/dwell-tracking/dwell-tracker-hooks.ts";

import { useEffectivePlanTitles } from "./hooks/effective-plan-titles.ts";
import { ContentfulFeature, PlanTitle } from "./types.ts";
import { transformContentfulDataToTableData } from "./utils";

export interface PricingTableWithoutFetchProps {
    tableData: ContentfulFeature[];
    planTitles: PlanTitle[];
    /**
     * Optional URL slug used to drive product-specific column filtering.
     * When the urlSlug matches a product whose visible plan set is gated
     * behind a feature flag (currently only `"product-discovery"`, see
     * GWP-10907), columns whose `planTitleExternal` is not in the active
     * allow-list are dropped — so CMS authors can stage new plan columns
     * without them appearing in production until the flag is on.
     */
    urlSlug?: string;
}

export const PricingTableWithoutFetch = (
    props: PricingTableWithoutFetchProps
) => {
    const { tableData = [], planTitles, urlSlug } = props;

    const effectivePlanTitles = useEffectivePlanTitles(planTitles, urlSlug);

    const transformedSections = transformContentfulDataToTableData(
        tableData,
        effectivePlanTitles
    );

    const dwellTimeAttributes = useDwellTimeElementAttributes({
        id: "pricing-table"
    });

    return (
        <div {...dwellTimeAttributes}>
            <Table
                header={{
                    titles: ["", ...effectivePlanTitles]
                }}
                sections={transformedSections as TableSectionsData}
            />
        </div>
    );
};
